import React, { FC, ReactNode } from "react";
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { ScreenSize } from '@constants/screen-size';

const Image = styled.img<{ isSmSmall: boolean }>`
  height: ${(props) => (props.isSmSmall ? "200px" : "260px")};
  width: auto;
`;

const EmptyState: FC<{ image: string, label?: string, children?: ReactNode; }> = ({
  image, label, children
}) => {
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });
  return (
    <div style={{margin: "auto", width: "fit-content" }}>
      <Image isSmSmall={isSmScreen} src={image}/>
      {label && (
        <Typography style={{textAlign: "center"}}>{label}</Typography>
      )}
      {children}
    </div>
  );
};

export default EmptyState;
